<template>
    <div v-if="open" class="popup-overlay">
      <div class="content" dir="rtl">
        <img src="/assets/img/flying.png" alt="FlyingCarpet Logo" class="popup-logo" />
        <button class="close-btn" @click="$emit('close')">×</button>
        <h2>🛫 טיסות חילוץ מהשטיח המעופף – חוזרים הביתה בביטחה!</h2><br />
        <p>
          השטיח המעופף מפעיל טיסות חילוץ ייעודיות מלרנקה (קפריסין) ו-בורגס (בולגריה) לעקבה (ירדן) – כולל הסעות מאורגנות עד לישראל.<br />
          המסלול כולל מעבר בלבד – ללא שהייה בירדן ומתאים לישראלים שתקועים בחו"ל ומעוניינים לשוב במהירות ובבטחה.<br /><br />
          <b>מה כוללת החבילה?</b><br />
            <ul style="text-align:right; direction:rtl; margin-right:2.5rem; margin-left:1.5rem;">
            <li>טיסה לעקבה</li>
            <li>אשרת מעבר + אגרת גבול (מאושרות מראש)</li>
            <li>הסעה משדה התעופה בעקבה לגבול ישראל (מעבר יצחק רבין)</li>
            <li>המשך הסעה מהגבול לחניון טווח ארוך בנתב"ג</li>
            <li>מזוודה + טרולי לכל נוסע</li>
            </ul>
            <br />
          <b>מחיר לנוסע:</b><br />
          <span class="align-right">
            • מלרנקה – 629$<br />
            • בורגס – 739$<br />
          </span><br />
          <b>מועדי טיסות:</b><br />
          <span class="align-right">
            מלרנקה לעקבה<br />
            <!-- <a :href="getFlightLink('larnaca', '2025-06-19', '15:15')" target="_blank" rel="noopener">🔗 19.6 – 15:15</a><br /> -->
            <a :href="getFlightLink('larnaca', '2025-06-22', '07:00')" target="_blank" rel="noopener">🔗 22.6 – 07:00</a> |
            <a :href="getFlightLink('larnaca', '2025-06-22', '12:20')" target="_blank" rel="noopener">🔗 22.6 – 12:20</a><br />
            <a :href="getFlightLink('larnaca', '2025-06-23', '07:00')" target="_blank" rel="noopener">🔗 23.6 – 07:00</a> |
            <a :href="getFlightLink('larnaca', '2025-06-23', '12:20')" target="_blank" rel="noopener">🔗 23.6 – 12:20</a><br /><br />
          </span><br />
          📌 הזמנות על בסיס מקום פנוי בלבד – מהרו להבטיח מקומכם!
        </p><br />
      </div>
    </div>
  </template>

<script>
export default {
  name: 'NotifyPopup',
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getFlightLink(airport, date, time) {
      let packId = '221538';
      let flights = '224383224403';

      if (airport === 'larnaca') {
        packId = '221537';
      } else if (airport === 'burgas') {
        packId = '221538';
      }

      if (date === '2025-06-19') {
        if (time === '15:15') {
          flights = '224385224386';
        }
      } else if (date === '2025-06-20') {
        if (time === '07:00') {
          flights = '224386224404';
        } else if (time === '12:20') {
          flights = '224386224386';
        }
      } else if (date === '2025-06-22') {
        if (time === '07:00') {
          flights = '224387224406';
        } else if (time === '12:20') {
          flights = '224387224387';
        }
      } else if (date === '2025-06-23') {
        if (time === '07:00') {
          flights = '224388224407';
        } else if (time === '12:20') {
          flights = '224388224388';
        }
      }

      return `https://www.flying.co.il/flight-only/web?packId=${packId}&dateFrom=${date}&flights=${flights}&categoryId=Flight_Only&adult=1&child=0&infant=0`;
    },
  },
};
</script>

<style scoped>
  .popup-overlay {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
  }
  .content {
    background: #fff;
    padding: 1.2rem;
    border-radius: 8px;
    max-width: 700px; /* wider for desktop */
    width: 90vw;      /* responsive width */
    text-align: center !important;
    position: relative;
    font-size: 1.25rem;
    margin: 0; /* Remove auto margin for more compactness */
    max-height: 90vh;
    overflow-y: auto;
  }
  .close-btn {
    position: absolute;
    top: 12px;
    left: 12px;
    background: transparent;
    border: none;
    font-size: 3.5rem;
    font-weight: 400;
    cursor: pointer;
    color: #333;
    padding: 0;
    line-height: 1;
  }
  button:not(.close-btn) {
    margin-top: 1rem;
    padding: 0.5rem 1.5rem;
  }
  h2 {
    font-size: 1.6rem; /* smaller header */
    margin-top: 1.2rem; /* increased margin from logo */
    margin-bottom: 0.5rem;
    text-align: center;
  }
  p {
    font-size: 1.35rem;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    text-align: center;
  }
  .popup-logo {
    max-width: 260px; /* larger logo */
    margin-top: 1.5rem;
    margin-bottom: 0.8rem; /* more space below logo */
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .align-right {
    display: block;
    text-align: center !important;
    direction: rtl;
    margin-right: 2.5rem;
    margin-left: 1.5rem;
  }

  @media (max-width: 900px) {
    .content {
      max-width: 98vw;
      padding: 0.7rem;
      font-size: 1.1rem;
    }
  }

  @media (max-width: 600px) {
    .content {
      padding: 0.5rem;
      max-width: 100vw;
      width: 100vw;
      font-size: 1rem;
      border-radius: 0;
    }
    .popup-logo {
      max-width: 160px; /* larger logo on mobile too */
      margin-top: 0.2rem;
      margin-bottom: 0.7rem; /* more space below logo on mobile */
    }
    h2 {
      font-size: 1.1rem; /* smaller header on mobile */
      margin-top: 0.7rem; /* increased margin from logo on mobile */
      margin-bottom: 0.2rem;
    }
    p {
      font-size: 1rem;
      margin-top: 0.2rem;
      margin-bottom: 0.2rem;
    }
    .close-btn {
      font-size: 2.2rem;
      top: 8px;
      left: 8px;
    }
    .align-right {
      margin-right: 0.5rem;
      margin-left: 0.5rem;
    }
  }
</style>
